import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export class IntroSectionAnimation {
  private section: HTMLElement | null = null;
  private scrollTrigger: ScrollTrigger | null = null;
  private reduceMotion = false;

  constructor() {
    this.reduceMotion =
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.section = document.querySelector('.intro-section');
    if (!this.section) return;

    const label = this.section.querySelector('.intro-section-label');
    const title = this.section.querySelector('.intro-section-title');
    const subtitle = this.section.querySelector('.intro-section-subtitle');
    const cards = this.section.querySelectorAll('.intro-card');

    const yOffset = this.reduceMotion ? 0 : 22;
    const ease = 'power3.out';

    gsap.set([label, title, subtitle, ...cards], {
      opacity: 0,
      y: yOffset,
      force3D: true,
    });

    const tl = gsap.timeline({
      paused: true,
      defaults: { ease, force3D: true },
    });

    tl.to(label, { opacity: 1, y: 0, duration: 0.4 })
      .to(title, { opacity: 1, y: 0, duration: 0.45 }, 0.08)
      .to(subtitle, { opacity: 1, y: 0, duration: 0.45 }, 0.2)
      .to(cards, { opacity: 1, y: 0, duration: 0.5, stagger: 0.1 }, 0.36);

    if (this.reduceMotion) {
      this.scrollTrigger = ScrollTrigger.create({
        trigger: this.section,
        start: 'top 85%',
        once: true,
        onEnter: () => tl.progress(1),
      });
      tl.progress(0);
      return;
    }

    // Scrubbed: timeline progress follows scroll through the section
    this.scrollTrigger = ScrollTrigger.create({
      trigger: this.section,
      start: 'top 90%',
      end: 'top 15%',
      scrub: 1.2,
      onUpdate: (self) => tl.progress(self.progress),
    });
  }

  dispose(): void {
    if (this.scrollTrigger) {
      this.scrollTrigger.kill();
      this.scrollTrigger = null;
    }
    this.section = null;
  }
}
